import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import titleIcon from "Explore/Assets/graduation_hat.png";
import institutionIcon from "Explore/Assets/institution_icon.png";
import noChartIcon from "Explore/Assets/no_chart.png";
import {
  ImageCheck,
  LinkWrapper,
  LoadingSimpleComponent,
  VerticalBar,
  CollaborationLink,
} from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import { ImageCheckType, SkeletonType } from "Explore/Config/ImageType";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FacultyEducation,
  FacultyExperiences,
  FacultyHonor,
  OtherProfile,
} from "..";
import styles from "./BasicInformation.module.scss";
import classNames from "classnames";

const BasicInformationLandscape = ({
  summary,
  citationStatistics,
  citationCount,
  acclaimAchievements,
  faculty_id,
}) => {
  const navigate = useNavigate();
  const [seeMore, setSeeMore] = useState(false);

  const unitInfo = useMemo(() => {
    if (!Array.isArray(summary?.data?.department)) return {};

    const data = summary?.data?.department.reduce((map, e) => {
      if (!e.parent_name) {
        // Root department
        map[e.name] = map[e.name] ?? {
          name: e.name,
          id: e.id,
          explore_slug: e.explore_slug,
          subUnits: [],
        };
      } else {
        // Sub department
        if (!map[e.parent_name]) {
          map[e.parent_name] = {
            name: e.parent_name,
            id: e.parent_id,
            explore_slug: e.parent_explore_slug,
            subUnits: [],
          };
        }
        map[e.parent_name].subUnits.push(e);
      }
      return map;
    }, {});
    return data;
    // const primaryDepartment = summary?.data?.department.filter((e) => e.is_primary);
    // const normalDepartment = summary?.data?.department.filter((e) => !e.is_primary);

    // const data = !!primaryDepartment.length > 0
    //   ? !!primaryDepartment.parent_name
    //     ? {
    //         [primaryDepartment.parent_name]: {
    //           id: primaryDepartment.parent_id,
    //           name: primaryDepartment.parent_name,
    //           subUnits: [primaryDepartment],
    //         },
    //       }
    //     : {
    //         [primaryDepartment.name]: {
    //           id: primaryDepartment.id,
    //           name: primaryDepartment.name,
    //           subUnits: [],
    //         },
    //       }
    //   : {};
    // return normalDepartment.reduce(
    //   (map, { parent_id, parent_name, ...item }) => {
    //     let newValue = {};
    //     if (!!parent_name) {
    //       newValue = map[parent_name] ?? {
    //         name: parent_name,
    //         id: parent_id,
    //         subUnits: [],
    //       };
    //       newValue.subUnits.push(item);
    //       map[parent_name] = newValue;
    //     } else {
    //       newValue = map[item.name] ?? {
    //         name: item.name,
    //         id: item.id,
    //         subUnits: [],
    //       };
    //       map[item.name] = newValue;
    //     }

    //     return map;
    //   },
    //   data,
    // );
  }, [summary?.data?.department]);

  return (
    <header className={styles["basic-information-landscape"]}>
      <div className={styles["personal-information"]}>
        <div className={styles["personal-information-main"]}>
          <LoadingSimpleComponent
            className="shrink-0"
            component={
              <div className={styles["avatar"]}>
                <ImageCheck
                  url={summary.data?.photo}
                  alt={"avatar"}
                  type={ImageCheckType.FACULTY_AVATAR}
                />
                {summary.data?.verified && (
                  <svg
                    className={styles["check"]}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.592 9.46049C16.8463 9.13353 16.7874 8.66232 16.4605 8.40802C16.1335 8.15372 15.6623 8.21262 15.408 8.53958L11.401 13.6914C11.3119 13.806 11.1443 13.8209 11.0364 13.7238L8.50173 11.4426C8.19385 11.1655 7.71963 11.1904 7.44254 11.4983C7.16544 11.8062 7.1904 12.2804 7.49828 12.5575L10.033 14.8387C10.7881 15.5183 11.9613 15.4143 12.585 14.6123L16.592 9.46049Z"
                      fill="var(--explore-color)"
                    />
                  </svg>
                )}
              </div>
            }
            type={SkeletonType.IMAGE}
            isLoading={summary.isLoading}
          />
          <div className={styles["personal-information-text"]}>
            <LoadingSimpleComponent
              className={styles["name"]}
              component={<h1 className={styles["name"]}>{summary.data?.name}</h1>}
              isLoading={summary.isLoading}
              type={SkeletonType.INPUT}
            />
            <LoadingSimpleComponent
              className={styles["loading-text"]}
              component={<p>{summary?.data.position}</p>}
              isLoading={summary.isLoading}
              type={SkeletonType.INPUT}
            />
            <div className={styles["links"]}>
              {summary.data.homepage && (
                <Tooltip title={"Personal page @ " + summary?.data.homepage}>
                  <IconButton
                    aria-label="Personal web"
                    size="small"
                    target="_blank" rel="noreferrer"
                    href={summary?.data.homepage}
                  >
                    {IconPack.homeWhite}
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </div>
        </div>
        <CollaborationLink
          entity={{
            id: summary.data?.id || faculty_id,
            name: summary.data?.name,
            type: "researcher",
            photo: summary.data?.photo,
            avatar: summary.data?.photo,
          }}
          variant="light"
          className={styles["faculty-collaboration-btn"]}
        />
      </div>

      <div className={styles["institution"]}>
        <img src={institutionIcon} alt="institution" />
        <LoadingSimpleComponent
          className={styles["loading-text"]}
          component={
            <LinkWrapper
              link={`/explore/institution/${summary.data?.institution?.explore_slug || summary.data?.institution?.id}`}
              component={<p>{summary.data?.institution?.name}</p>}
            />
          }
          type={SkeletonType.INPUT}
          isLoading={summary.isLoading}
        />
      </div>

      <div className={styles["unit"]}>
        <div className={styles["unit--icon"]}>{IconPack.students}</div>
        <div className={styles["unit__body"]}>
          <h2 className={styles["unit--title"]}>Affiliations</h2>
          <div className={styles["unit__content"]}>
            <LoadingSimpleComponent
              className={styles["unit__content--info"]}
              component={Object.entries(unitInfo).map(
                ([name, { id, explore_slug, name: unitName, subUnits }]) => (
                  <div key={name} className={styles["unit__content--info--item"]}>
                    <LinkWrapper
                      link={`/explore/unit/${explore_slug || id}`}
                      component={
                        <p
                          className={classNames(
                            styles["unit__content--info--item--name"],
                            styles["link"]
                          )}
                        >
                          {unitName}
                        </p>
                      }
                    />
                    <div>
                      {subUnits.map((item) => (
                        <LinkWrapper
                          key={item.id}
                          link={`/explore/unit/${item.explore_slug || item.id}`}
                          component={
                            <p
                              className={classNames(
                                styles["unit__content--info--item--sub-name"],
                                styles["link"]
                              )}
                            >
                              {item.name}
                            </p>
                          }
                        />
                      ))}
                    </div>
                  </div>
                )
              )}
              isLoading={summary.isLoading}
              type={SkeletonType.INPUT}
            />
          </div>
        </div>
      </div>

      <div className={styles["basic-informations"]}>
        <div className={styles["work-history"]}>
          {/* <div className={styles["work-info"]}>
            <div
              className={styles["line-profile"]}
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (summary.data?.department.id)
                  navigate(
                    `/explore/institution/${summary.data?.department?.explore_slug || summary.data?.department?.id}`
                  );
              }}
            >
              <img src={institutionIcon} alt="institution" />
              <LoadingSimpleComponent
                className={styles["loading-text"]}
                component={<p>{summary.data?.department?.inst_name}</p>}
                type={SkeletonType.INPUT}
                isLoading={summary.isLoading}
              />
            </div>
          </div>
          <div className={styles["work-info"]}>
            <div className={styles["line-profile"]}>
              {IconPack.students}
              <LoadingSimpleComponent
                className={styles["loading-text"]}
                component={
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {summary.data?.department?.name?.map((item, index) => (
                      <p key={index}>{item}</p>
                    ))}
                  </div>
                }
                isLoading={summary.isLoading}
                type={SkeletonType.INPUT}
              />
            </div>
          </div>
          <div className={styles["work-info"]}>
            <div className={styles["line-profile"]}>
              <img src={titleIcon} alt="title" />
              <LoadingSimpleComponent
                className={styles["loading-text"]}
                component={<p>{summary?.data.position}</p>}
                isLoading={summary.isLoading}
                type={SkeletonType.INPUT}
              />
            </div>
          </div> */}
          <div className={styles["work-info"]}>
            <div className={styles["line-profile"]}>
              {IconPack.info_black}
              <LoadingSimpleComponent
                className={styles["loading-text"]}
                component={
                  <div className={seeMore ? styles[""] : styles["description"]}>
                    <p>{summary.data?.biography}</p>
                    {!seeMore && (
                      <p
                        className={styles["see-more"]}
                        onClick={() => setSeeMore(true)}
                      >
                        See more
                      </p>
                    )}
                    {seeMore && (
                      <p
                        className={styles["see-more"]}
                        onClick={() => setSeeMore(false)}
                      >
                        See less
                      </p>
                    )}
                  </div>
                }
                type={SkeletonType.PARAGRAPH}
                isLoading={summary.isLoading}
              />
            </div>
          </div>
          {summary.data.publication_count > 0 && (
            <div
              style={{
                marginTop: "10px",
                borderBottom: "1px solid var(--light-grey)",
              }}
            >
              {citationStatistics.isLoading && citationStatistics.data.length > 0 && (
                <>
                  <p style={{ fontWeight: "bold" }}>
                    Cited by {citationCount ? citationCount : ""}
                  </p>
                  <VerticalBar data={citationStatistics.data} />
                </>
              )}
            </div>
          )}
          {summary?.data?.duplicated_with_cross_institutions?.length > 0 && (
            <div className={styles["other-profiles"]}>
              <h2 className={styles["title-section"]}>Other profiles</h2>
              <div className={styles["profiles"]}>
                {summary?.data?.duplicated_with_cross_institutions?.map(
                  (item, index) => {
                    return <OtherProfile item={item} index={index} />;
                  }
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={styles["achievements"]}>
        <FacultyHonor
          data={{
            data: acclaimAchievements.honors,
            isLoading: acclaimAchievements.isLoading,
            source_url: acclaimAchievements.honor_awards_source_url,
          }}
        />
        <FacultyExperiences
          data={{
            data: acclaimAchievements.experiences,
            isLoading: acclaimAchievements.isLoading,
            source_url: acclaimAchievements.work_experience_source_url,
          }}
        />
        <FacultyEducation
          data={{
            data: acclaimAchievements.education,
            isLoading: acclaimAchievements.isLoading,
            source_url: acclaimAchievements.education_source_url,
          }}
        />
      </div>
    </header>
  );
};

export default BasicInformationLandscape;
